export default __webpack_public_path__ + "static/media/snowflakelogo.37017fdc.png";